import React from 'react';
import styled from 'styled-components';

const BannerWrapper = styled.div`
  height: 60px;
  position: relative;
  width: 100%;

  @media ${({ theme }) => theme.v2.breakpoints.Min.desktop} {
    height: 40px;
  }
`;

const BannerContainer = styled.div`
  background: ${({ background }) => background};
  height: ${({ height }) => height || 'auto'};
  padding: 9px 16px;
  overflow: hidden;
  width: 100%;
  z-index: 1;
  position: absolute;
  bottom: -60px;

  @media ${({ theme }) => theme.v2.breakpoints.Min.tablet} {
    height: ${({ height }) => height || '40px'};
    bottom: -40px;
  }

  @media ${({ theme }) => theme.v2.breakpoints.Min.desktop} {
    height: ${({ height }) => height || '40px'};
    position: relative;
    bottom: 0px;
  }
`;

const SimpleBanner = ({ children, background, height = null }) => {
  return (
    <BannerWrapper>
      <BannerContainer background={background} height={height}>
        {children}
      </BannerContainer>
    </BannerWrapper>
  );
};

export { SimpleBanner };
